<div [formGroup]="contractCoOwnerForm">

    <ng-container *ngIf="headline">
        <h2>{{ headline }}</h2>
    </ng-container>


    <mat-checkbox [disabled]="disabled"
                  [(ngModel)]="captureContractCoOwner"
                  [ngModelOptions]="{standalone: true}">
        {{ 'workflows.formWidgets.contractCoOwner.captureCoOwner' | translate }}
    </mat-checkbox>

    <ng-container *ngIf="captureContractCoOwner">
        <section class="pt-12">
            <mat-tab-group>
                <ng-container *ngFor="let i of [1,2,3,4]">
                    <mat-tab [label]="'workflows.formWidgets.contractCoOwner.coOwnerTab' | translate:{ n: i }">

                        <div class="py-24">
                            <div fxLayout="column wrap">
                                <mat-form-field [appearance]="appearance" fxFlex="100" floatLabel="always">
                                    <mat-label>{{ 'workflows.formWidgets.contractCoOwner.fullNameLabel' | translate }}</mat-label>
                                    <input matInput
                                           type="text"
                                           data-test="FI-Titel"
                                           [formControlName]="'VMI_' + i + '_NAME_KOMPLETT'"
                                           autocomplete="new-password">
                                    <mat-error>{{ contractCoOwnerForm.get('VMI_' + i + '_NAME_KOMPLETT').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>

                                <mat-form-field [appearance]="appearance" fxFlex="100" floatLabel="always">
                                    <mat-label>{{ 'workflows.formWidgets.contractCoOwner.streetLabel' | translate }}</mat-label>
                                    <input matInput
                                           type="text"
                                           data-test="FI-Straße"
                                           [formControlName]="'VMI_' + i + '_STR'"
                                           autocomplete="new-password">
                                    <mat-error>{{ contractCoOwnerForm.get('VMI_' + i + '_STR').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>

                                <mat-form-field [appearance]="appearance" fxFlex="50" floatLabel="always">
                                    <mat-label>{{ 'workflows.formWidgets.contractCoOwner.postalCodeLabel' | translate }}</mat-label>
                                    <input matInput
                                           type="text"
                                           data-test="FI-PLZ"
                                           [formControlName]="'VMI_' + i + '_PLZ'"
                                           autocomplete="new-password">
                                    <mat-error>{{ contractCoOwnerForm.get('VMI_' + i + '_PLZ').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>

                                <mat-form-field [appearance]="appearance" fxFlex="50" floatLabel="always">
                                    <mat-label>{{ 'workflows.formWidgets.contractCoOwner.cityLabel' | translate }}</mat-label>
                                    <input matInput
                                           type="text"
                                           data-test="FI-Ort"
                                           [formControlName]="'VMI_' + i + '_ORT'"
                                           autocomplete="new-password">
                                    <mat-error>{{ contractCoOwnerForm.get('VMI_' + i + '_ORT').errors | firstErrorMessage }}</mat-error>
                                </mat-form-field>

                            </div>
                        </div>
                    </mat-tab>
                </ng-container>
            </mat-tab-group>
        </section>
    </ng-container>

</div>
